import React, { lazy, Suspense, useEffect, useState } from "react";
import DefaultModal from "../DefaultModal";
import { useAppSelector } from "../../../store/index.ts";
import { useLocalStorage } from "usehooks-ts";
import { ENUM_LCS_NAME } from "../../../store/enums.js";
import RegisterFortune from "./register_fortune/RegisterFortune.jsx";
import { dispatchCusEvent } from "../../../utils/utils.js";
import { ENUM_TAWK_API } from "../../../hooks/other/useTawkController.js";
import LoaderContainer from "../../mui/loader_container/LoaderContainer.jsx";

const FortuneModalContent = lazy(() => import("./FortuneModalContent.jsx"));

export default function FortuneModal({ isOpen, closeModal }) {
  const [isFortune, setFortune] = useLocalStorage(ENUM_LCS_NAME.isFortune);

  const fortuneLock = useAppSelector((state) => state.site.lock.fortuneClose);
  const currencyDefault = useAppSelector((state) => state.common.currencyDefault);

  const [isRegister, setRegister] = useState(false);
  const [currency, setCurrency] = useState(currencyDefault);

  useEffect(() => {
    if (currency) return;
    setCurrency(currencyDefault);
  }, [currencyDefault, currency]);

  const checkTawn = (isShow) => {
    isShow ? dispatchCusEvent(ENUM_TAWK_API.hide) : dispatchCusEvent(ENUM_TAWK_API.show);
  };

  useEffect(() => {
    if (isFortune && isOpen) setRegister(true);
    checkTawn(isOpen);
  }, [isFortune, isOpen]);

  return (
    <>
      <DefaultModal
        classModal={`fortune-modal `}
        isOpen={isOpen}
        closeModal={closeModal}
        hideClose={fortuneLock}
        isFull>
        {isOpen && (
          <Suspense fallback={<LoaderContainer loader center fullHeight />}>
            <FortuneModalContent
              currency={currency}
              setFortune={setFortune}
              setCurrency={setCurrency}
              setRegister={setRegister}
            />
          </Suspense>
        )}
      </DefaultModal>

      <RegisterFortune
        isOpen={isRegister}
        currency={currency}
        hideClose={fortuneLock}
        setCurrency={setCurrency}
        closeModal={() => {
          setRegister(false);
          closeModal();
        }}
      />
    </>
  );
}
